/**
 * KAN-2610: phone numbers are stored as free text (e.g. "555-555-5555" from the
 * Pulse Cardiac Rehab import), but the Contact form edits them in a numeric
 * input. Always go through these helpers instead of `Number(phoneNumber)`,
 * which turns any non-digit character into NaN and used to make a save of the
 * Contact card delete the phone.
 */

/** The digits of a stored or typed phone ("555-555-5555" -> "5555555555"). */
export const phoneDigits = (value: string | number | null | undefined): string =>
	value === null || value === undefined ? "" : String(value).replace(/\D/g, "");

/**
 * The value the numeric phone input should show for a stored phone, or null
 * when it cannot be shown losslessly as a number: no digits, a leading zero,
 * or more than 15 digits (the E.164 maximum, and beyond safe JS integers).
 * A null here means "the form did not load this phone", never "the user
 * cleared it" - see setRequestPhone.
 */
export const parsePhoneForForm = (value: string | number | null | undefined): number | null => {
	const digits = phoneDigits(value);
	if (!digits || digits.length > 15 || digits.startsWith("0")) return null;
	return Number(digits);
};
